import { diYu } from './common-var'

export default {
  data: function() {
    return {
      tableHeads: [
        {
          label: '操作',
          type: 'link',
          width: 30,
          content: '',
          icon: 'el-icon-setting',
          onClick: item => {
            if (item['手机']) {
              this.showAction(item)
            } else {
              this.$message.info('该人选为cc，请补全手机后操作')
            }
          },
        },
        {
          label: '意向',
          type: 'select',
          width: 30,
          options: {
            Y: 'Y.积极看机会',
            N: 'N.暂时不看机会',
            F: 'F.再跟进',
          },
          colors: { Y: '#f99', N: '#ffc', F: '#ccf' },
          onChange: params => {
            const { item, value } = params
            this.changeYi(item, value)
          },
        },
        { label: '跟进责任人', field: '归属人' },
        {
          label: '竞争',
          type: 'select',
          width: 30,
          options: {
            I: 'I.内推',
            Y: 'Y.猎头推荐',
            '': '空',
          },
          colors: { I: '#ffc', Y: '#f99' },
          onChange: params => {
            const { item, value } = params
            this.changeJing(item, value)
          },
        },
        {
          label: '长意',
          field: '长期意向',
          type: 'select',
          width: 30,
          options: {
            Y: 'Y.积极看机会',
            N: 'N.暂时不看机会',
            F: 'F.再跟进',
          },
          colors: { Y: '#f99', N: '#ffc', F: '#ccf' },
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        {
          label: '附件',
          type: 'attach',
          width: 40,
          onClick: item => {
            this.showFiles(item)
          },
        },
        {
          label: '姓名',
          type: 'link',
          onClick: item => {
            this.clickName(item)
          },
          onClickSimi: item => {
            this.getSimi(item)
          },
        },
        { label: '英文名' },
        {
          label: '人选进展阶段',
          type: 'tag',
          width: 130,
          onClick: item => {
            this.clickStatus(item)
          },
        },
        { label: '曾任职公司' },
        {
          label: '公司',
          type: 'link',
          onClick: item => {
            if (item['公司排名'] == '9999991') {
              app.root.$refs.radishEditCompany.show({ _id: item.rid, 公司: item['公司'] })
            } else {
              this.clickCompany(item['公司'])
            }
          },
          editType: 'input',
        },
        { label: '部门', width: 150, editType: 'input' },
        { label: '组别', width: 150, editType: 'input' },
        { label: '目前职位', editType: 'input' },
        {
          label: '手机',
          type: 'tooltip',
          width: 90,
          onMouseover: item => {
            if (item.手机 === '***') {
              this.getPhone(item.rid)
            }
          },
        },
        { label: '其他', width: 90 },
        { label: '座机' },
        { label: '邮箱' },
        { label: '地域', type: 'tag', options: diYu, editType: 'createSelect' },
        {
          label: '性别',
          width: 30,
          type: 'select',
          options: ['男', '女'],
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        { label: '规模' },
        { label: '管理基金数量' },
        { label: '管理基金' },
        { label: '任职期' },
        { label: '任职期限' },
        { label: '行业', options: app.industries || [], editType: 'select' },
        { label: '职能模块', type: 'tag', width: 140 },
        { label: '建议职能模块', type: 'tag', width: 140 },
        { label: '细分职能', type: 'tag', editType: 'multSelect' },
        {
          label: '平台',
          type: 'select',
          width: 40,
          options: {
            A: 'A.大平台',
            B: 'B.中平台',
            C: 'C.小平台',
          },
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        {
          label: '职级',
          type: 'select',
          width: 40,
          options: {
            '1': '1.高管',
            '2': '2.部门总',
            '3': '3.部门副总/总助/团队长',
            '4': '4.部门核心骨干',
            '5': '5.新人三年以下',
          },
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        {
          label: '业绩',
          type: 'select',
          width: 40,
          options: { aaa: 'aaa.领军人物', aa: 'aa.卓越人选', a: 'a.优秀人选', b: 'b.良好', c: 'c.一般', d: 'd.较差' },
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        { label: '擅长方向', type: 'tag', editType: 'multSelect' },
        { label: '投资风格', editType: 'select', options: ['GARP型', '价值型', '成长型', '极致成长型', '综合型'] },
        { label: '个性标签' },
        { label: '学历标签', type: 'tag' },
        { label: '语言标签', type: 'tag' },
        { label: '职业资格', type: 'tag' },
        { label: '旧系统沟通备注', width: 120 },
        {
          label: '沟通日志',
          width: 120,
          type: 'tooltip',
          handleContent: function(content) {
            const res = content.replace(/(\d{4}\-\d{2}\-\d{2})/g, '\n<b>$1</b> ')
            return res
          },
        },
        {
          label: '公司变动',
          type: 'select',
          width: 60,
          options: ['Y', ''],
          onChange: params => {
            this.editOneField(params)
          },
          editType: 'select',
        },
        {
          label: '离职意愿度',
          handleContent: value => {
            if (value) {
              if (value > 80) {
                return '离职动机强'
              } else if (value > 60) {
                return '有机会会动'
              } else {
                return '观望不拒绝机会'
              }
            } else {
              return '--'
            }
          },
        },
        { label: '管理职级', editType: 'input' },
        { label: '专业职级', editType: 'input' },
        { label: '下属个数' },
        { label: '汇报上级', editType: 'input' },
        { label: '期望行业', type: 'tag' },
        { label: '期望地域', type: 'tag' },
        { label: '期望固薪' },
        { label: '期望奖金' },
        { label: '简介' },
        { label: '婚育' },
        { label: '出生年月' },
        { label: '籍贯' },
        { label: '学历' },
        { label: '本科院校' },
        { label: '硕士院校' },
        { label: '到现公司时间' },
        { label: '从业起始年' },
        { label: '微信' },
        { label: '投资年限' },
        { label: '平台性质', type: 'tag', width: 140 },
        { label: '投资阶段', type: 'tag', width: 140 },
        { label: '人员背景', type: 'tag', width: 140 },
        { label: '特殊能力', type: 'tag', width: 140 },
        { label: '个人风格', type: 'tag', width: 140 },
        // { label: '是否量产', type: 'tag', width: 140 },
        // { label: '是否流片', type: 'tag', width: 140 },
        { label: '承揽-承做', type: 'tag', width: 140 },
        { label: '期望职能', type: 'tag', width: 140 },
        // { label: '人员背景（股）', type: 'tag', width: 140 },
        { label: '医疗科室', type: 'tag', width: 140 },
        { label: '业务方向', type: 'tag', width: 140 },
        { label: '上市经验', type: 'tag', width: 140 },
        { label: '业务类型', type: 'tag', width: 140 },
        // { label: '医疗背景', type: 'tag', width: 140 },
        // { label: '人才来源', type: 'tag', width: 140 },
        { label: '公开业绩', type: 'tag', width: 140 },
        { label: '投资标的', type: 'tag', width: 140 },
        { label: '转换诉求', type: 'tag', width: 140 },
        // { label: '港股背景', type: 'tag', width: 140 },
        { label: '意向平台', type: 'tag', width: 140 },
        // { label: '人选背景', type: 'tag', width: 140 },
        { label: 'REITs任职情况', type: 'tag', width: 140 },
        { label: '公司类型', type: 'tag', width: 140 },
        { label: '会计准则及证书', type: 'tag', width: 140 },
        { label: '项目及其他技能', type: 'tag', width: 140 },
        { label: '金融业务方向', type: 'tag', width: 140 },
        { label: '技术方向', type: 'tag', width: 140 },
        { label: '治疗领域', type: 'tag', width: 140 },
        { label: '技术赛道', type: 'tag', width: 140 },
        { label: '实体瘤', type: 'tag', width: 140 },
        { label: '医药程序员', type: 'tag', width: 140 },
        // { label: '中后台背景', type: 'tag', width: 140 },
        { label: 'HR背景', type: 'tag', width: 140 },
        { label: '薪酬', type: 'tag', width: 140 },
        { label: '保荐项目数量', width: 140 },
        { label: '首发保荐项目数量', width: 140 },
        { label: '首发持续督导保荐项目数量', width: 140 },
        { label: '可转债保荐项目数量', width: 140 },
        { label: '可转债持续督导保荐项目数量', width: 140 },
        { label: '非公开保荐项目数量', width: 140 },
        { label: '非公开持续督导保荐项目数量', width: 140 },
      ],
    }
  },
}
